<template>
<div>
	<confirm-container>
		<div slot-scope="{info}" slot="recognizeInfo">
			<RecognizeInfoForPerson :info="info" v-if="type=='person'"/>
			<RecognizeInfoForCar :info="info" v-if="type=='car'"/>
		</div>
		<div slot="agree">
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险（2025版A款）条款 (主险).pdf" target="_blank">《平安产险雇主责任保险（2025版A款）条款 (主险)》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加高处（高空）作业扩展保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加高处（高空）作业扩展保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加及时报案保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加及时报案保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加申报工资保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加申报工资保险（2025版）条款（附加险）》</a><br />
			<a href="/static/pdf/haierProduct/huoche/平安产险责任保险附加伤残赔偿比例保险（2025版A款）条款（附加险）.pdf" target="_blank">《平安产险责任保险附加伤残赔偿比例保险（2025版A款）条款（附加险）》</a>
			<a href="/static/pdf/haierProduct/huoche/平安产险雇主责任保险附加职业类别限定保险（2025版）条款（附加险）.pdf" target="_blank">《平安产险雇主责任保险附加职业类别限定保险（2025版）条款（附加险）》</a>
		</div>
	</confirm-container>
</div>
</template>
<script>
import ConfirmContainer from '@/pages/haierProduct/components/common/ConfirmContainer'
import RecognizeInfoForPerson from './person/RecognizeInfo'
import RecognizeInfoForCar from './car/RecognizeInfo'
export default {
	components:{ 
		ConfirmContainer,
		RecognizeInfoForPerson,
		RecognizeInfoForCar
	},
	data () {
		return {
			type:this.$route.params.type||''
		}
	},
	created(){
	},
	methods:{
		
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
		font-size: 25px;
		line-height: 1.8;
	}
	span.price{
		color:#FF0000;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/Confirm.vue